import * as React from 'react';
import { Header1, InlineText1, LinkButton, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

import { trackDownloadReportClick, trackGoToFormClick } from '../../../../containers/PageContainer/trackings';
import { NBSP } from '../../../../constants/symbols';
import { EPromoPriceSize, PromoPrice } from '../../../PromoPrice';

import * as styles from './styles.css';

export interface IReportExampleInfoProps {
  reportExampleLink: string;
  price: string;
  buyLink: string;
  promoPriceText?: string | null;
  oldPrice?: string | null;
  termsOfPromotion?: string | null;
}

export const ReportExampleInfo: React.FC<IReportExampleInfoProps> = props => {
  const { reportExampleLink, buyLink, price, promoPriceText, oldPrice, termsOfPromotion } = props;
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';
  const btnSize = isDesktop ? 'M' : 'L';
  const hasPromo = Boolean(promoPriceText && oldPrice);
  const buttonText = hasPromo ? 'Заказать отчёт' : `Заказать за ${price}`;

  return (
    <>
      <Header1 color="white_100">Наш отчёт — больше, чем анализ выписки из{NBSP}ЕГРН</Header1>
      <ul className={styles['list']}>
        <li>
          <InlineText1 color="white_100">
            Опытные юристы, а не робот, анализируют документы и{NBSP}готовят рекомендации, в случае возникновения рисков
          </InlineText1>
        </li>
        <li>
          <InlineText1 color="white_100">Изучают правоустанавливающие документы</InlineText1>
        </li>
        <li>
          <InlineText1 color="white_100">
            Проверяют продавца на банкротство, причастность к{NBSP}уголовным делам и т.д.
          </InlineText1>
        </li>
        <li>
          <InlineText1 color="white_100">
            Убеждаются, что объект недвижимости не является аварийным, на него не наложен арест и т.д.
          </InlineText1>
        </li>
      </ul>
      <div className={cn(styles['buttons'], styles[deviceType])}>
        <LinkButton
          data-testid="report_example_buy"
          onClick={() => trackGoToFormClick('demo')}
          href={buyLink}
          theme="fill_white_primary"
          size={btnSize}
          fullWidth={!isDesktop}
        >
          {buttonText}
        </LinkButton>
        <LinkButton
          data-testid="report_example_download"
          onClick={trackDownloadReportClick}
          href={reportExampleLink}
          theme="fill_white_secondary"
          size={btnSize}
          fullWidth={!isDesktop}
          target="_blank"
        >
          Скачать пример отчёта
        </LinkButton>
      </div>
      {hasPromo && (
        <div className={styles['promo-text']}>
          <PromoPrice
            price={price}
            promoPriceText={promoPriceText as string}
            oldPrice={oldPrice as string}
            size={EPromoPriceSize.XS}
            termsOfPromotion={termsOfPromotion as string}
          />
        </div>
      )}
    </>
  );
};

ReportExampleInfo.displayName = 'ReportExampleInfo';
